import { SAVE_TRACK_SCREEN_TIMING, SAVE_USER_REPORT_UTILIZATION_EVENT, TOAST_ERROR } from "Constants/actionConstants";
import { CONTRACTING_MODULE_ID } from "Constants/commonConstants";
import { call , takeLatest, put } from "redux-saga/effects";
import { DOWNLOAD_FILE_URL, getDataWithToken, SAVE_TRACK_SCREEN_TIMING_URL, SAVE_USER_REPORT_UTILIZATION_EVENT_URL } from "Utils/api";
import { axiosT2 } from "Utils/axios";
import { isValueThere } from "Utils/index";
import { getItemFromLocal } from "Utils/localStorage";
import { getItemFromSessionStorage, removeItemToSessionStorage } from "Utils/sessionStorage";
import { getToken, getUser } from "Utils/storage";

export function* saveUserReportUtilizationEvent(action) {
  const headers = {
	  token: getToken(),
	};
  const userInfo = getUser() || {};
  const branchDetail = getItemFromLocal('branchDetail') || {};
  const payload = {
    ...(action.payload || {}),
    user_name: userInfo.adminName,
    user_email: userInfo.email,
    company_id: userInfo.companyId,
    company_name: userInfo.companyName,
    event_trigger_time: new Date().getTime(),
    company_type: userInfo.companyType,
    branch_name:  branchDetail.branch_name || userInfo.branchName,
    branch_id :  branchDetail.branch_id || userInfo.branchId,
    is_active : userInfo.is_active,
    module_id: CONTRACTING_MODULE_ID,
  }

  try {
    yield call(
      axiosT2.post,
      SAVE_USER_REPORT_UTILIZATION_EVENT_URL,
      payload,
      {
        headers
      }
    );
  } catch (e) {
    console.log("e:", e);
  }
}

export function* saveTrackScreenTiming(action) {
  const headers = {
	  token: getToken(),
	};
  const userInfo = getUser() || {}; 
  const branchDetail = getItemFromLocal('branchDetail') || {};
   const temp_user_info = getItemFromSessionStorage('temp_user_info') 
  let payload = {
    ...(action.payload || {}),
    user_name: userInfo.adminName,
    user_email: userInfo.email,
    company_id: userInfo.companyId,
    company_name: userInfo.companyName,
    company_type: userInfo.companyType,
    branch_name:  branchDetail.branch_name || userInfo.branchName,
    branch_id :  branchDetail.branch_id || userInfo.branchId,
    is_active : userInfo.is_active,
    module_id: CONTRACTING_MODULE_ID,
  }

    if(isValueThere(temp_user_info)){
    payload = {
      ...(action.payload || {}),
      user_name: temp_user_info.adminName,
      user_email: temp_user_info.email,
      company_id: temp_user_info.companyId,
      company_name: temp_user_info.companyName,
      company_type: temp_user_info.companyType,
      branch_name: branchDetail.branch_name || temp_user_info.branchName,
      branch_id: branchDetail.branch_id || temp_user_info.branchId,
      is_active: temp_user_info.is_active,
      module_id: CONTRACTING_MODULE_ID,
    }
    removeItemToSessionStorage("temp_user_info");
    removeItemToSessionStorage("track_href");
    removeItemToSessionStorage("screen_landing_time");
  }
  
  try {

    yield call(
      axiosT2.post,
      SAVE_TRACK_SCREEN_TIMING_URL,
      payload,
      {
        headers
      }
    );

    if (!!action.onSuccess) {
      action.onSuccess();
    }

  } catch (e) {
    console.log("e:", e);
  }
}


export function* getPresignedUrl(action) {
  try {
    const data = action?.data?.data || '';
    const presignedUrlParams = {
      fileName: data?.name,
      companyId: getUser()?.companyId,
      seekerCompanyId: getItemFromLocal("transporter_seeker_company_id")
    };

    const presignedUrlDetails = yield call(
      getDataWithToken,
      DOWNLOAD_FILE_URL,
      presignedUrlParams
    );
    const presignedUrlData = {
      name: data?.name,
      url: presignedUrlDetails?.url,
    };

    return presignedUrlData;
  } catch (e) {
    yield put({
      type: TOAST_ERROR,
      message: e?.message || "Oops! Something Went Wrong",
    });
  }
}

export function* commonSaga() {
  yield takeLatest(SAVE_USER_REPORT_UTILIZATION_EVENT, saveUserReportUtilizationEvent);
  yield takeLatest(SAVE_TRACK_SCREEN_TIMING, saveTrackScreenTiming);
}
